import { SVGProps, Ref, forwardRef } from 'react';

export const CameraFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2 6.001 5.038C.802 5.274 0 6.73 0 13v1c0 7 1 8 8 8h8c7 0 8-1 8-8v-1c0-6.27-.802-7.726-6.001-7.962L16 2zm1.8 11c0-.733.187-1.272.458-1.598.223-.267.675-.602 1.742-.602s1.52.335 1.742.602c.271.326.458.865.458 1.598s-.187 1.272-.458 1.598c-.223.267-.675.602-1.742.602s-1.52-.335-1.742-.602C9.987 14.272 9.8 13.733 9.8 13M8 13c0-2 1-4 4-4s4 2 4 4-1 4-4 4-4-2-4-4"
                fill="currentColor"
            />
        </g>
    </svg>
));
CameraFilledSize24Glyph.displayName = 'CameraFilledSize24Glyph';
